import { Pipe, PipeTransform } from '@angular/core';

import { MomentService } from './moment.service';

@Pipe({
    name: 'eventDate',
    standalone: false
})
export class EventDatePipe implements PipeTransform {

    constructor(private momentSvc: MomentService) {
    }

    transform(value: string | Date, ...args: any[]): string {
        if (!value) {
            return '';
        }
        // TODO: Since pipes cache results, we need to reload the app when another event is selected
        const timeZone = args[0];
        const formatType = args[1];
        return this.momentSvc.toEventDateTime(value, timeZone, formatType);
    }
}
